export const MEDICATION_TEXT_MAX_LENGTH = 255;

export const EMPTY_MEDICATION_VALUES = {
  medication_name: '',
  dosage: '',
  start_date: null,
  physician_name: '',
  reason: '',
} as const;
